import { useTranslation } from '@pancakeswap/localization'
import { ButtonMenu, ButtonMenuItem, useMatchBreakpoints } from '@pancakeswap/uikit'
import { memo, useState, useMemo, useEffect } from 'react'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { ChainId, Currency } from '@pancakeswap/sdk'

import styled from 'styled-components'
import { fetchedTokenDatas, useFetchedTokenDatas, useTopTokenAddresses } from 'views/Info/Overview/hooks'
import { SUBGRAPH_START_BLOCK } from 'views/V3Info/constants'
import { getDeltaTimestamps } from 'utils/getDeltaTimestamps'
import { TokenData } from 'state/info/types'
import { useBlockFromTimeStampSWR } from 'views/Info/hooks/useBlocksFromTimestamps'
import TokenTable from './SwapTokenTable'

// import { useTokenHighLightList } from './useList'

const Wrapper = styled.div`
  padding-top: 10px;
  ${({ theme }) => theme.mediaQueries.lg} {
    width: 725px;
    padding: 24px;
    box-sizing: border-box;
    background: #1b2b45;
    border-radius: 16px;
  }
`
const MenuWrapper = styled.div`
  .wrapper-btn {
    background: #162237;
    height: 44px;
    margin-bottom: 24px;
    button {
      display: flex;
      align-items: center;

      line-height: 0;
    }
  }
`

const LIQUIDITY_FILTER = { [ChainId.BSC]: 100000, [ChainId.ETHEREUM]: 50000 }

const HotTokenList: React.FC<{ handleOutputSelect: (newCurrencyOutput: Currency) => void }> = ({
  handleOutputSelect,
}) => {
  const { chainId } = useActiveChainId()
  const { addresses: addressesTokens } = useTopTokenAddresses()

  // const { data: tokenDatas } = useFetchedTokenDatas(addressesTokens || [])

  const [tokenData, setTokenData] = useState<any>()

  const [t24, t48, t7d] = getDeltaTimestamps()
  const { blocks } = useBlockFromTimeStampSWR([t24, t48, t7d])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-extra-semi
    ;(async () => {
      const { data: tokenDatas } = await fetchedTokenDatas(
        addressesTokens || [],
        blocks?.filter((d) => d.number >= SUBGRAPH_START_BLOCK[chainId]),
      )

      setTokenData(tokenDatas)
    })()
  }, [addressesTokens, blocks, chainId])
  const allTokens: TokenData[] = Object.values(tokenData || {})

  const [index, setIndex] = useState(0)
  const { isMobile } = useMatchBreakpoints()

  const formattedTokens = allTokens

  const { t } = useTranslation()

  return (
    <Wrapper>
      <MenuWrapper>
        <ButtonMenu
          activeIndex={index}
          onItemClick={setIndex}
          fullWidth
          scale="sm"
          variant="subtle"
          className="wrapper-btn"
        >
          <ButtonMenuItem
            style={{
              padding: '8px 0',
            }}
          >
            {t('Price Change')}
          </ButtonMenuItem>
          <ButtonMenuItem
            style={{
              padding: '8px 0',
            }}
          >
            {t('Volume (24H)')}
          </ButtonMenuItem>
        </ButtonMenu>
      </MenuWrapper>
      {index === 0 ? (
        <TokenTable
          tokenDatas={formattedTokens}
          type="priceChange"
          defaultSortField="priceUSDChange"
          // type={chainId === ChainId.BSC ? 'priceChange' : 'liquidity'}
          // defaultSortField={chainId === ChainId.BSC ? 'priceUSDChange' : 'liquidityUSD'}
          maxItems={isMobile ? 100 : 6}
          handleOutputSelect={handleOutputSelect}
        />
      ) : (
        <TokenTable
          tokenDatas={formattedTokens}
          type="volume"
          defaultSortField="volumeUSD"
          maxItems={isMobile ? 100 : 6}
          handleOutputSelect={handleOutputSelect}
        />
      )}
    </Wrapper>
  )
}

export default memo(HotTokenList)
